module.exports = __webpack_public_path__ + "static/media/007.cddf86db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/007.jpg
// module id = 480
// module chunks = 0